import C from 'utils/values/constant.util';

const KPI_UNIT = C({
  currency: 'pound',
  percent: 'percent',
  count: 'count',
});

export default KPI_UNIT;
